import { defineMessages } from 'react-intl';

import generalMessages from 'src/messages';

const messages = defineMessages({
  subTitle: {
    id: 'subTitle',
    defaultMessage:
      'Upload your bulk upload template file (.xls, .csv, .txt format)',
  },
  successUploadedSubTitle: {
    id: 'successUploadedSubTitle',
    defaultMessage: 'File uploaded',
  },
  failed: {
    id: 'failed',
    defaultMessage: 'Failed',
  },
  plateError: {
    id: 'plateError',
    defaultMessage: `One of your plates has errors. 
    Only valid plates and sequences can be added to your cart. 
    Please edit the plate(s) to fix all errors in order to add them to your cart.`,
  },
  fileUploadError: {
    id: 'fileUploadError',
    defaultMessage: `The file format is invalid. 
      The online oligo order system can only accept Excel files (.xls/.xlsx) 
      and comma (.csv) or tab delimited (.txt) files.`,
  },
  plateRemoveError: {
    id: 'plateRemoveError',
    defaultMessage: 'Removing plate {name} has failed. Try again.',
  },
  plateRemoveSuccess: {
    id: 'plateRemoveSuccess',
    defaultMessage: 'Sucessfully removed plate {name}.',
  },
  lastPlateRemoveSuccess: {
    id: 'lastPlateRemoveSuccess',
    defaultMessage: 'Sucessfully removed plate {name}. Since this was your last plate your file ' +
      'has also been removed. Please reupload a new file to start over.',
  },
  platesSummaryRefreshError: {
    id: 'platesSummaryRefreshError',
    defaultMessage: 'There was an issue refreshing your plates summary. ' +
      'Data might be inconsistent. Please try to reupload the file if the problem persists.',
  },
});

export default { ...generalMessages, ...messages };
